(function () {
  if (window.__pvgZoomInit) return;
  window.__pvgZoomInit = true;

  var dialog = null;
  var track = null;
  var currentProductId = null;

  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.id = 'pvg-zoom';
    dialog.innerHTML =
      '<button class="pvg-zoom__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="pvg-zoom__arrow pvg-zoom__arrow--prev" type="button" aria-label="Previous image">&#8249;</button>' +
      '<button class="pvg-zoom__arrow pvg-zoom__arrow--next" type="button" aria-label="Next image">&#8250;</button>' +
      '<div class="pvg-zoom__track" id="pvg-zoom-track"></div>';
    document.body.appendChild(dialog);
    track = dialog.querySelector('#pvg-zoom-track');

    dialog.querySelector('.pvg-zoom__close').addEventListener('click', closeDialog);
    dialog.querySelector('.pvg-zoom__arrow--prev').addEventListener('click', function () { scrollTrack(-1); });
    dialog.querySelector('.pvg-zoom__arrow--next').addEventListener('click', function () { scrollTrack(1); });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', syncMainGalleryToCurrentSlide);
  }

  function scrollTrack(direction) {
    if (!track || !track.clientWidth) return;
    track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
  }

  function getCurrentVariantImages(productId) {
    var dataEl = document.getElementById('pvg-data-' + productId);
    if (!dataEl) return null;
    var allVariants;
    try { allVariants = JSON.parse(dataEl.textContent); } catch (e) { return null; }

    var stage = document.getElementById('pvg-stage-' + productId);
    var variantId = stage && stage.dataset.variantId;
    if (variantId && allVariants[variantId] && allVariants[variantId].length) {
      return allVariants[variantId];
    }
    var firstKey = Object.keys(allVariants)[0];
    return firstKey ? allVariants[firstKey] : null;
  }

  function getCurrentSlideIndex(productId) {
    var stage = document.getElementById('pvg-stage-' + productId);
    if (!stage || !stage.clientWidth) return 0;
    return Math.round(stage.scrollLeft / stage.clientWidth);
  }

  function render(productId, startIndex) {
    ensureDialog();
    currentProductId = productId;
    var images = getCurrentVariantImages(productId);
    if (!images || !images.length) return;

    var html = '';
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      var alt = (img.alt || '').replace(/"/g, '&quot;');
      html +=
        '<div class="pvg-zoom__slide" data-index="' + i + '">' +
        '<img src="' + img.src + '" alt="' + alt + '" loading="' + (i === startIndex ? 'eager' : 'lazy') + '">' +
        '</div>';
    }
    track.innerHTML = html;

    if (!dialog.open) dialog.showModal();

    requestAnimationFrame(function () {
      var target = track.children[startIndex];
      if (target) {
        track.scrollLeft = target.offsetLeft;
      }
    });
  }

  function closeDialog() {
    if (dialog && dialog.open) dialog.close();
  }

  function syncMainGalleryToCurrentSlide() {
    if (!currentProductId || !track) return;
    var stage = document.getElementById('pvg-stage-' + currentProductId);
    if (!stage || !track.clientWidth) return;
    var index = Math.round(track.scrollLeft / track.clientWidth);
    var stageSlideWidth = stage.clientWidth;
    if (!stageSlideWidth) return;
    stage.scrollLeft = index * stageSlideWidth;
    stage.dispatchEvent(new Event('scroll'));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.pvg__zoom-btn');
    var stageImg = !btn && e.target.closest && e.target.closest('.pvg__stage img');
    if (!btn && !stageImg) return;

    var pvg = e.target.closest('.pvg');
    if (!pvg || !pvg.id) return;
    var productId = pvg.id.replace(/^pvg-/, '');
    var startIndex = getCurrentSlideIndex(productId);
    e.preventDefault();
    render(productId, startIndex);
  });

  document.addEventListener('variant:update', function () {
    if (dialog && dialog.open && currentProductId) {
      render(currentProductId, 0);
    }
  });
})();
